import {
	Autocomplete as MAutocomplete,
	Chip,
	createFilterOptions,
	TextField,
	Tooltip,
} from '@mui/material';
import { CSSProperties } from 'react';

interface Props {
	getTooltipTitle(value: number): string;
	id: string;
	onChange(value: number[]): void;
	options: number[];
	placeholder: string;
	style?: CSSProperties;
	value: number[];
	size?: 'small' | 'medium';
	className?: string;
}

const Autocomplete: React.FC<Props> = ({
	getTooltipTitle,
	id,
	onChange,
	options,
	placeholder,
	style,
	value,
	size,
	className,
}) => (
	<MAutocomplete
		filterSelectedOptions
		multiple
		filterOptions={createFilterOptions({
			matchFrom: 'any',
			stringify: (option) => `${option}. ${getTooltipTitle(option)}`,
		})}
		getOptionLabel={(combo) => `${combo}. ${getTooltipTitle(combo)}`}
		isOptionEqualToValue={(option, value) =>
			`${option}. ${getTooltipTitle(option)}` === `${value}. ${getTooltipTitle(value)}`
		}
		noOptionsText="No hay más opciones"
		onChange={(_e, value) => onChange(value.sort((a, b) => a - b))}
		options={options}
		renderInput={(props) => (
			<TextField
				{...props}
				size={size || 'small'}
				className={className}
				placeholder={placeholder}
			/>
		)}
		renderTags={(tagsValue, getTagProps) =>
			tagsValue.map((combo, index) => (
				<Tooltip
					arrow
					key={`${id}_${combo}_${index}`}
					placement="left"
					title={getTooltipTitle(combo)}
				>
					<Chip
						{...getTagProps({ index })}
						label={combo}
						style={{ backgroundColor: '#1063AC29' }}
					/>
				</Tooltip>
			))
		}
		size="small"
		style={style}
		value={value}
	/>
);

export default Autocomplete;
